export const getPeriodId = () => {
	const host = window.location.host
	if (host.indexOf('eduteacher') > -1) {
		return 4
	} else {
		return 0
	}
}
